import React, { useState, useEffect, useCallback, useRef } from "react";
import { fetchPastUnfulfilledOrders, todayStr } from "./pastUnfulfilledUtils";
import PastUnfulfilledModal from "./PastUnfulfilledModal";

// Orari in cui deve comparire il promemoria (solo admin)
const SLOTS = ["07:30", "08:30", "11:30", "16:00"];

const PastUnfulfilledAlert = () => {
  const [open, setOpen] = useState(false);
  const [orders, setOrders] = useState([]);
  const checkingRef = useRef(false);

  // Recupera gli ordini arretrati e, se ce ne sono, mostra il popup
  const fetchAndShow = useCallback(async () => {
    if (checkingRef.current) return;
    checkingRef.current = true;
    try {
      const scaduti = await fetchPastUnfulfilledOrders();
      if (scaduti.length > 0) {
        setOrders(scaduti);
        setOpen(true);
      }
    } catch (err) {
      console.error("Errore controllo ordini non evasi:", err);
    } finally {
      checkingRef.current = false;
    }
  }, []);

  // Mostra il promemoria una volta per fascia oraria al giorno
  const checkSlots = useCallback(() => {
    const now = new Date();
    const oggi = todayStr();
    const nowMin = now.getHours() * 60 + now.getMinutes();

    let slotDaMostrare = null;
    SLOTS.forEach((s) => {
      const [h, m] = s.split(":").map(Number);
      const slotMin = h * 60 + m;
      const key = `grv_pastAlert_${oggi}_${s}`;
      if (nowMin >= slotMin && !localStorage.getItem(key)) {
        slotDaMostrare = s; // tiene l'ultima fascia già passata e non ancora mostrata
      }
    });

    if (slotDaMostrare) {
      // Marca come "mostrate" tutte le fasce già passate, per non impilare più popup
      SLOTS.forEach((s) => {
        const [h, m] = s.split(":").map(Number);
        if (nowMin >= h * 60 + m) {
          localStorage.setItem(`grv_pastAlert_${oggi}_${s}`, "1");
        }
      });
      fetchAndShow();
    }
  }, [fetchAndShow]);

  useEffect(() => {
    checkSlots(); // controllo iniziale all'apertura
    const id = setInterval(checkSlots, 60 * 1000); // e poi ogni minuto
    return () => clearInterval(id);
  }, [checkSlots]);

  return (
    <PastUnfulfilledModal
      open={open}
      orders={orders}
      onClose={() => setOpen(false)}
    />
  );
};

export default PastUnfulfilledAlert;
